export const LEGAL_VERSION = '2026-08-23';

// Set this when the extra checkbox wording is provided. Leave empty to hide it.
export const ADDITIONAL_CONSENT_LABEL = '';
